module.exports = __webpack_public_path__ + "img/head.33813198.png";